import { render, staticRenderFns } from "./MatrixComponent.vue?vue&type=template&id=05eddf32&"
import script from "./MatrixComponent.vue?vue&type=script&lang=js&"
export * from "./MatrixComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports